module.exports = __webpack_public_path__ + "static/media/trophy-gif.af045908.gif";